<template>
  <article id="article-fund-performance" v-if="detail">
    <section id="section-performance">
      <div class="perf-select">
        <select class="dropdown-select" v-model="typePerf">
          <option
            :data-action="getAction(item)"
            v-for="(item, index) in dropdownSelect"
            :key="index"
            v-bind:value="item"
          >{{ item }}</option>
        </select>
        <div class="dropdown-select-label">
          แสดงผลตอบแทนคู่กับ
          <span>{{ typePerf }}</span>
        </div>
      </div>
      <div class="perf-toggle">
        <div class="toggle-box">
          <toggle-button
            :data-action="toggleAverage ? 'compare_group_on' : 'compare_group_off'"
            v-model="toggleAverage"
            color="#17c161"
            :height="toggleBox.height"
            :width="toggleBox.width"
          />
        </div>
        <span class="toggle-remark">เทียบค่าเฉลี่ยในกลุ่ม</span>
      </div>

      <div class="perf-list">
        <div class="perf-item">
          <div class="perf-value">
            <div class="perf-col-first">
              <h4>3M</h4>
            </div>
            <div class="perf-col-second">
              <div>
                <h4>Return</h4>
                <p>{{ detail.total_return_3m != null ? numberToFixed(detail.total_return_3m)+'%' : '-' }}</p>
                <a href="javascript:;" class="value-pill excellent">ดีที่สุด</a>
              </div>
            </div>
            <div class="perf-col-third">
              <h4>{{typePerf}}</h4>
              <p>{{ dynamicValue3M.percent ? numberToFixed(dynamicValue3M.percent)+'%' : '-' }}</p>
            </div>
          </div>
          <div class="perf-avg" v-if="toggleAverage">
            <div class="perf-col-first">
              <h4>เฉลี่ยในกลุ่ม</h4>
            </div>
            <div class="perf-col-second">
              <p>{{ detail.total_return_avg_3m != null ? numberToFixed(detail.total_return_avg_3m)+'%' : '-' }}</p>
            </div>
            <div class="perf-col-third">
              <p>{{ dynamicValue3M.avg ? numberToFixed(dynamicValue3M.avg)+'%' : '-' }}</p>
            </div>
          </div>
        </div>

        <div class="perf-item">
          <div class="perf-value">
            <div class="perf-col-first">
              <h4>6M</h4>
            </div>
            <div class="perf-col-second">
              <div>
                <h4>Return</h4>
                <p>{{ detail.total_return_6m != null ? numberToFixed(detail.total_return_6m)+'%' : '-' }}</p>
                <a href="javascript:;" class="value-pill excellent">ดีที่สุด</a>
              </div>
            </div>
            <div class="perf-col-third">
              <h4>{{typePerf}}</h4>
              <p>{{ dynamicValue6M.percent ? numberToFixed(dynamicValue6M.percent)+'%' : '-' }}</p>
            </div>
          </div>
          <div class="perf-avg" v-if="toggleAverage">
            <div class="perf-col-first">
              <h4>เฉลี่ยในกลุ่ม</h4>
            </div>
            <div class="perf-col-second">
              <p>{{ detail.total_return_avg_6m != null ? numberToFixed(detail.total_return_avg_6m)+'%' : '-' }}</p>
            </div>
            <div class="perf-col-third">
              <p>{{ dynamicValue6M.avg ? numberToFixed(dynamicValue6M.avg)+'%' : '-' }}</p>
            </div>
          </div>
        </div>

        <div class="perf-item">
          <div class="perf-value">
            <div class="perf-col-first">
              <h4>1Y</h4>
            </div>
            <div class="perf-col-second">
              <div>
                <h4>Return</h4>
                <p>{{ detail.total_return_1y != null ? numberToFixed(detail.total_return_1y)+'%' : '-' }}</p>
                <a href="javascript:;" class="value-pill excellent">ดีที่สุด</a>
              </div>
            </div>
            <div class="perf-col-third">
              <h4>{{typePerf}}</h4>
              <p>{{ dynamicValue1Y.percent ? numberToFixed(dynamicValue1Y.percent)+'%' : '-' }}</p>
            </div>
          </div>
          <div class="perf-avg" v-if="toggleAverage">
            <div class="perf-col-first">
              <h4>เฉลี่ยในกลุ่ม</h4>
            </div>
            <div class="perf-col-second">
              <p>{{ detail.total_return_avg_1y != null ? numberToFixed(detail.total_return_avg_1y)+'%' : '-' }}</p>
            </div>
            <div class="perf-col-third">
              <p>{{ dynamicValue1Y.avg ? numberToFixed(dynamicValue1Y.avg)+'%' : '-' }}</p>
            </div>
          </div>
        </div>

        <div class="perf-item">
          <div class="perf-value">
            <div class="perf-col-first">
              <h4>3Y</h4>
            </div>
            <div class="perf-col-second">
              <div>
                <h4>Return</h4>
                <p>{{ detail.total_return_3y != null ? numberToFixed(detail.total_return_3y)+'%' : '-' }}</p>
                <a href="javascript:;" class="value-pill excellent">ดีที่สุด</a>
              </div>
            </div>
            <div class="perf-col-third">
              <h4>{{typePerf}}</h4>
              <p>{{ dynamicValue3Y.percent ? numberToFixed(dynamicValue3Y.percent)+'%' : '-' }}</p>
            </div>
          </div>
          <div class="perf-avg" v-if="toggleAverage">
            <div class="perf-col-first">
              <h4>เฉลี่ยในกลุ่ม</h4>
            </div>
            <div class="perf-col-second">
              <p>{{ detail.total_return_avg_3y != null ? numberToFixed(detail.total_return_avg_3y)+'%' : '-' }}</p>
            </div>
            <div class="perf-col-third">
              <p>{{ dynamicValue3Y.avg ? numberToFixed(dynamicValue3Y.avg)+'%' : '-' }}</p>
            </div>
          </div>
        </div>

        <div class="perf-item">
          <div class="perf-value">
            <div class="perf-col-first">
              <h4>5Y</h4>
            </div>
            <div class="perf-col-second">
              <div>
                <h4>Return</h4>
                <p>{{ detail.total_return_5y != null ? numberToFixed(detail.total_return_5y)+'%' : '-' }}</p>
                <a href="javascript:;" class="value-pill excellent">ดีที่สุด</a>
              </div>
            </div>
            <div class="perf-col-third">
              <h4>{{typePerf}}</h4>
              <p>{{ dynamicValue5Y.percent ? numberToFixed(dynamicValue5Y.percent)+'%' : '-' }}</p>
            </div>
          </div>
          <div class="perf-avg" v-if="toggleAverage">
            <div class="perf-col-first">
              <h4>เฉลี่ยในกลุ่ม</h4>
            </div>
            <div class="perf-col-second">
              <p>{{ detail.total_return_avg_5y != null ? numberToFixed(detail.total_return_avg_5y)+'%' : '-' }}</p>
            </div>
            <div class="perf-col-third">
              <p>{{ dynamicValue5Y.avg ? numberToFixed(dynamicValue5Y.avg)+'%' : '-' }}</p>
            </div>
          </div>
        </div>

        <div class="perf-item">
          <div class="perf-value">
            <div class="perf-col-first">
              <h4>10Y</h4>
            </div>
            <div class="perf-col-second">
              <div>
                <h4>Return</h4>
                <p>{{ detail.total_return_10y != null ? numberToFixed(detail.total_return_10y)+'%' : '-' }}</p>
                <a href="javascript:;" class="value-pill excellent">ดีที่สุด</a>
              </div>
            </div>
            <div class="perf-col-third">
              <h4>{{typePerf}}</h4>
              <p>{{ dynamicValue10Y.percent ? numberToFixed(dynamicValue10Y.percent)+'%' : '-' }}</p>
            </div>
          </div>
          <div class="perf-avg" v-if="toggleAverage">
            <div class="perf-col-first">
              <h4>เฉลี่ยในกลุ่ม</h4>
            </div>
            <div class="perf-col-second">
              <p>{{ detail.total_return_avg_10y != null ? numberToFixed(detail.total_return_avg_10y)+'%' : '-' }}</p>
            </div>
            <div class="perf-col-third">
              <p>{{ dynamicValue10Y.avg ? numberToFixed(dynamicValue10Y.avg)+'%' : '-' }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section v-if="returnData" id="section-performance-graph">
      <h2>Performance</h2>
      <bar-chart :id="'return-bar-chart'" data-action="view_perf_bar" :data="returnData"></bar-chart>
      <span
        class="remark"
      >* ข้อมูลการจัดอันดับ Performance และ Standard Deviation ยึดจากสมาคมบริษัทจัดการลงทุนโดย</span>
      <ul class="remark-pill">
        <li>
          <a href="javascript:;" class="value-pill excellent">ดีที่สุด</a> = อยู่ในช่วงเปอร์เซ็นไทล์ 1-5
        </li>
        <li>
          <a href="javascript:;" class="value-pill great">ดีมาก</a> = อยู่ในช่วงเปอร์เซ็นไทล์ 5-25
        </li>
        <li>
          <a href="javascript:;" class="value-pill good">ดี</a> = อยู่ในช่วงเปอร์เซ็นไทล์ 25-50
        </li>
      </ul>
      <span
        class="remark"
      >* ข้อมูลที่แสดงทั้งหมดมาจากแหล่งข้อมูลที่น่าเชื่อถือ เช่น มอร์นิ่งสตาร์ หรือ เว็บไซต์ของบริษัทหลักทรัพย์จัดการกองทุน เป็นต้น อย่างไรก็ตาม ฟินโนมีนาไม่รับรองถึงความถูกต้องสมบูรณ์ของข้อมูลดังกล่าว</span>
    </section>
  </article>
</template>
<script>
import { ToggleButton } from "vue-js-toggle-button";
import BarChart from "../../../components/miniapp/fund/BarChart.vue";
import { mapActions } from "vuex";
export default {
  components: {
    BarChart,
    ToggleButton
  },
  data() {
    return {
      toggleBox: {
        width: 53,
        height: 34
      },
      dropdownSelect: ["SD", "Sharpe Ratio", "Max Drawdown", "Unit Change"],
      typeSelected: "SD",
      shouldStick: true,
      toggleAverage: false,
      arrPerformance: [],
      returnData: [],
      typePerf: "SD"
    };
  },
  props: {
    id: {
      type: String,
      default: ""
    },
    detail: {
      type: Object,
      default: null
    }
  },
  computed: {
    dynamicValue3M() {
      let result = {};
      switch (this.typePerf) {
        case "SD":
          result.percent = this.detail.std_3m;
          result.avg = this.detail.std_avg_3m;
          break;
        case "Sharpe Ratio":
          result.percent = this.detail.sharpe_ratio_3m;
          result.avg = this.detail.sharpe_ratio_avg_3m;
          break;
        case "Max Drawdown":
          result.percent = this.detail.max_drawdown_3m;
          result.avg = this.detail.sharpe_ratio_avg_3m;
          break;
        case "Unit Change":
          result.percent = this.detail.unit_change_3m;
          result.avg = "";
          break;
        default:
          result.percent = null;
          result.avg = null;
      }
      return result;
    },
    dynamicValue6M() {
      let result = {};
      switch (this.typePerf) {
        case "SD":
          result.percent = this.detail.std_6m;
          result.avg = this.detail.std_avg_6m;
          break;
        case "Sharpe Ratio":
          result.percent = this.detail.sharpe_ratio_6m;
          result.avg = this.detail.sharpe_ratio_avg_6m;
          break;
        case "Max Drawdown":
          result.percent = this.detail.max_drawdown_6m;
          result.avg = this.detail.sharpe_ratio_avg_6m;
          break;
        case "Unit Change":
          result.percent = this.detail.unit_change_16m;
          result.avg = "";
          break;
        default:
          result.percent = null;
          result.avg = null;
      }
      return result;
    },
    dynamicValue1Y() {
      let result = {};
      switch (this.typePerf) {
        case "SD":
          result.percent = this.detail.std_1y;
          result.avg = this.detail.std_avg_1y;
          break;
        case "Sharpe Ratio":
          result.percent = this.detail.sharpe_ratio_1yr;
          result.avg = this.detail.sharpe_ratio_avg_1yr;
          break;
        case "Max Drawdown":
          result.percent = this.detail.max_drawdown_1yr;
          result.avg = this.detail.max_drawdown_avg_1yr;
          break;
        case "Unit Change":
          result.percent = this.detail.unit_change_1y;
          result.avg = "";
          break;
        default:
          result.percent = null;
          result.avg = null;
      }
      return result;
    },
    dynamicValue3Y() {
      let result = {};
      switch (this.typePerf) {
        case "SD":
          result.percent = this.detail.std_3y;
          result.avg = this.detail.std_avg_3y;
          break;
        case "Sharpe Ratio":
          result.percent = this.detail.sharpe_ratio_3yr;
          result.avg = this.detail.sharpe_ratio_avg_3yr;
          break;
        case "Max Drawdown":
          result.percent = this.detail.max_drawdown_3yr;
          result.avg = this.detail.max_drawdown_avg_3yr;
          break;
        case "Unit Change":
          result.percent = this.detail.unit_change_3y;
          result.avg = "";
          break;
        default:
          result.percent = null;
          result.avg = null;
      }
      return result;
    },
    dynamicValue5Y() {
      let result = {};
      switch (this.typePerf) {
        case "SD":
          result.percent = this.detail.std_5y;
          result.avg = this.detail.std_avg_5y;
          break;
        case "Sharpe Ratio":
          result.percent = this.detail.sharpe_ratio_5yr;
          result.avg = this.detail.sharpe_ratio_avg_5yr;
          break;
        case "Max Drawdown":
          result.percent = this.detail.max_drawdown_5yr;
          result.avg = this.detail.max_drawdown_avg_5yr;
          break;
        case "Unit Change":
          result.percent = this.detail.unit_change_5y;
          result.avg = "";
          break;
        default:
          result.percent = null;
          result.avg = null;
      }
      return result;
    },
    dynamicValue10Y() {
      let result = {};
      switch (this.typePerf) {
        case "SD":
          result.percent = this.detail.std_10y;
          result.avg = this.detail.std_avg_10y;
          break;
        case "Sharpe Ratio":
          result.percent = this.detail.sharpe_ratio_10yr;
          result.avg = this.detail.sharpe_ratio_avg_10yr;
          break;
        case "Max Drawdown":
          result.percent = this.detail.max_drawdown_10yr;
          result.avg = this.detail.max_drawdown_avg_10yr;
          break;
        case "Unit Change":
          result.percent = this.detail.unit_change_10y;
          result.avg = "";
          break;
        default:
          result.percent = null;
          result.avg = null;
      }
      return result;
    }
  },
  watch: {
    async id(id) {
      await this.queryData(id);
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  async mounted() {
    await this.queryData(this.id);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    ...mapActions("fund", ["findFundPerformance"]),
    async queryData(id) {
      this.arrPerformance = await this.findFundPerformance(id);
      if (this.arrPerformance && this.arrPerformance.return) {
        this.returnData = this.arrPerformance.return.filter(data => data.value);
      }
    },
    numberToFixed(num) {
      return num ? parseFloat(num).toFixed(2) : 0;
    },
    selectType(type) {
      this.typePerf = type;
    },
    getAction(item) {
      switch (item) {
        case "SD":
          return "display_sd";
        case "Sharpe Ratio":
          return "display_sharpe";
        case "Max Drawdown":
          return "display_maxdd";
        case "Unit Change":
          return "display_unit_chg";
        default:
          return "display_sd";
      }
    },
    handleScroll() {
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      this.$emit("current-scroll", currentScrollPosition);
    }
  }
};
</script>
<style lang="scss" scoped>
#article-fund-performance {
  #section-performance {
    @extend %container-style;
    margin: 0 auto;
    .perf-toggle {
      display: inline-block;
      .toggle-box {
        display: inline-block;
      }
      .toggle-remark {
        display: inline-block;
        @extend %font-size-ss;
        margin-left: 16px;
      }
    }
    .perf-list {
      margin: 0;
      display: inline-block;
      width: 100%;
      .perf-item {
        border-radius: 4px;
        border: solid 1px $color-border;
        margin: 16px 0;
        .perf-value,
        .perf-avg {
          width: 100%;

          padding: 16px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          .perf-col-first {
            width: 25%;
            h4 {
              @extend %font-size-s;
              color: $color-secondary-text;
            }
          }
          .perf-col-second {
            width: 37.5%;
            text-align: center;
            align-self: flex-start;
            h4 {
              @extend %font-size-s;
              font-weight: normal;
              color: $color-normal-text;
            }
            p {
              @extend %font-size-s;
              font-weight: bold;
              color: $color-normal-text;
              margin: 8px;
            }
            a {
              margin: 0 auto;
              display: block;
            }
          }
          .perf-col-third {
            width: 37.5%;
            text-align: center;
            align-self: flex-start;
            h4 {
              @extend %font-size-s;
              font-weight: normal;
              color: $color-normal-text;
            }
            p {
              @extend %font-size-s;
              font-weight: bold;
              color: $color-normal-text;
              margin: 8px;
            }
          }
          // .perf-col-fourth {
          //   width: 25%;
          //   text-align: center;
          //   align-self: flex-start;
          //   h4 {
          //     @extend %font-size-ss;
          //     font-weight: normal;
          //     color: $color-normal-text;
          //   }
          //   p {
          //     @extend %font-size-ss;
          //     font-weight: bold;
          //     color: $color-normal-text;
          //   }
          // }
        }
        .perf-avg {
          background-color: #f9f9f9;
          padding: 8px 16px;
        }
      }
    }
  }
  #section-performance-graph {
    @extend %container-style;
    margin: 32px auto;
    h2 {
      @extend %font-size-m;
      margin-bottom: 8px;
    }
    .remark {
      @extend %font-size-sss;
      color: $color-normal-text;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      display: block;
      margin: 15px 0;
    }
    .remark-pill {
      margin: 0;
      padding: 0;
      list-style: none;
      li {
        margin: 10px 0;
        padding: 0;
        font-size: 10px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: $color-normal-text;
        a {
          display: inline-block;
          margin-right: 10px;
        }
      }
    }
  }
  .value-pill {
    border-radius: 12px;
    width: 55px;
    height: 20px;
    color: $color-white;
    text-decoration: none;
    font-size: 10px;
    padding: 2px 0;
    text-align: center;
  }
  .excellent {
    background-color: #108a48;
  }
  .great {
    background-color: #25c970;
  }
  .good {
    background-color: #85d5aa;
  }
  .perf-select {
    z-index: 9;
    margin: 12px 0;
    position: relative;
    width: 100%;
    .dropdown-select {
      width: 100%;
      display: inline-block;
      padding: 11px 16px !important;
      @extend %font-size-s;
      color: $color-normal-text;
      background-color: #efefef;
      border-radius: 6px;
      box-shadow: 0 0 4px 0 rgba(186, 186, 186, 0.24);
      border: solid 1px #f9f9f9;
      z-index: 1;
      height: 51px;
      &:focus {
        outline: none;
      }
      span {
        font-weight: bold;
      }
    }
    .dropdown-select-label {
      pointer-events: none;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      display: inline-block;
      padding: 11px 16px;
      @extend %font-size-s;
      color: $color-normal-text;
      background-color: #efefef;
      border-radius: 6px;
      box-shadow: 0 0 4px 0 rgba(186, 186, 186, 0.24);
      border: solid 1px #f9f9f9;
      z-index: 2;
      &:after {
        content: "\f107";
        font-family: "Font Awesome 5 Pro";
        font-size: 18px;
        width: 20px;
        height: 20px;
        position: absolute;
        right: 15px;
        top: 15px;
      }
      span {
        font-weight: bold;
      }
    }
  }
  h4 {
    text-align: center;
  }
}
</style>